import storage_zone_config from "@/components/StorageZone/config";

export default {
  singleLabel: "Entrepôt",
  storeNamespace: 'warehouse',
  authFeature: 'warehouse',
  listRouteName: "WarehouseList",
  newRouteName: "WarehouseNew",
  editRouteName: "WarehouseEdit",
  detailRouteName: "WarehouseDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'WarehouseForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: "name",
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      // FAC-007b : agence commerciale SAP du dépôt (colonnes G et H de l'export
      // « FactureGlobale »). Éditable ici plutôt qu'en config : le client la révise.
      name: 'sap_agency_code',
      label: "Agence commerciale SAP",
      type: 'text',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      description: "Code agence SAP du dépôt (ex. IAW, IAE, IL8). Alimente les colonnes « Agence Commerciale » et « Centre de Ventes » de l'export SAP.",
    },
    {
      name: 'address',
      label: "Adresse",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
    },
    {
      name: 'email',
      label: "E-mail",
      type: 'email',
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="mailto:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'phone_number',
      label: "Téléphone",
      type: 'tel',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
      link: (context, value) => value ? 'tel:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="tel:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'fax_number',
      label: "Fax",
      type: 'tel',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
    },
    {
      name: 'chronopost_url',
      label: "URL formulaire Chronopost",
      type: 'text',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
    },
    {
      name: 'chronopost_account',
      label: "Compte Chronopost",
      type: 'text',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
    },
    {
      // Colonne de synthèse : icône quand l'URL du formulaire Chronopost est saisie,
      // cf. le slot `chronopost` de WarehouseList.
      name: 'chronopost',
      label: "Chronopost",
      type: 'text',
      inForm: false,
      inList: true,
      inDetail: false,
    },
    {
      // Colonne de synthèse : les deux coordonnées valent surtout par leur PRÉSENCE.
      // Sans elles, le transport au départ de l'entrepôt bascule en zone maximale — d'où le
      // rendu en alerte, cf. le slot `coordinates` de WarehouseList.
      name: 'coordinates',
      label: "Coordonnées",
      type: 'text',
      inForm: false,
      inList: true,
      inDetail: false,
    },
    {
      // Coordonnées GPS : distance de livraison pour les frais de transport
      name: 'latitude',
      label: "Latitude",
      type: 'number',
      step: 'any',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
    },
    {
      name: 'longitude',
      label: "Longitude",
      type: 'number',
      step: 'any',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'storage_zones',
      label: "Zones de stockage",
      type: 'list',
      icone: 'warehouse',
      config: storage_zone_config,
      fields: ['name', 'internal_code']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Warehouse/config.js